import PropTypes from "prop-types";
import { SuiModal } from "../../common/suiModal";
import { walmartMXTranslations } from "../../../translations/walmartMXTranslations";
import { useIntl } from "react-intl";

const BrandLiftSelectionModal = ({ isOpen, onClose, onConfirm }) => {
  const intl = useIntl();
  return (
    <SuiModal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader={intl.formatMessage({
        id: "HEADER_BRAND_LIFT",
        defaultMessage: "Brand Lift",
      })}
      modalContent={
        <ul>
          <li>{walmartMXTranslations.brandLiftSelectionModalPt1}</li>
          <li>{walmartMXTranslations.brandLiftSelectionModalPt2}</li>
        </ul>
      }
      modalButtons={[
        { text: "Cerrar", onClick: onClose },
        { text: "Aceptar", color: "primary", onClick: onConfirm },
      ]}
      modalSize="tiny"
    />
  );
};

BrandLiftSelectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default BrandLiftSelectionModal;
